import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = new BehaviorSubject<string>('en');
  currentLang$ = this.currentLang.asObservable();

  private translations: { [key: string]: any } = {
    en: {
      'OTHER_LANGUAGE_STORIES': 'Stories in Other Languages',
      'NEW_RELEASES': 'New Releases', 'TRENDING': 'Trending', 'CATEGORIES': 'Categories', 'TOP_WRITERS': 'Top Writers', 'CONTINUE_READING': 'Continue Reading', 'SEE_ALL': 'See All', 'SEE_MORE': 'See More', 'SEE_LESS': 'See Less', 'BY': 'By', 'READS': 'reads', 'VIEWS': 'Views', 'READ_NOW': 'Read Now', 'ADD_TO_LIBRARY': 'Add to Library', 'REMOVE_FROM_LIBRARY': 'Remove from Library', 'FOLLOW': 'Follow', 'UNFOLLOW': 'Unfollow', 'STORIES': 'Stories', 
       'CATEGORIES_MENU': 'Categories', 
       'WRITING_CONTEST': 'Writing Contest', 
       'SEARCH_PLACEHOLDER': 'Search for stories...', 
       'SIGN_IN': 'Sign In', 
       'SIGN_OUT': 'Sign Out', 
       'CONTINUE_NEXT':'Continue Next',
       'WRITE': 'Write', 
       'MY_STORIES': 'My Stories',
        'MY_PROFILE': 'My Profile', 
        'LIBRARY': 'Library', 'LANGUAGE': 'Language',  'EDIT_PROFILE': 'Edit Profile', 'FULL_NAME': 'Full Name', 'EMAIL_ADDRESS': 'Email Address', 'USERNAME': 'Username', 'MOBILE_NUMBER': 'Mobile Number', 'ABOUT_ME': 'About Me', 'TELL_US_ABOUT_YOURSELF': 'Tell us about yourself', 'PREFERRED_LANGUAGE': 'Preferred Language', 'CHANGE_PASSWORD': 'Change Password', 'CURRENT_PASSWORD': 'Current Password', 'NEW_PASSWORD': 'New Password', 'CONFIRM_PASSWORD': 'Confirm Password', 'UPDATE_PROFILE': 'Update Profile', 'UPDATING': 'Updating...', 'CHANGE_COVER': 'Change Cover', 'UPLOADING': 'Uploading...', 'CHARACTERS': 'characters', 'UNABLE_TO_DETERMINE_USER_ID': 'Unable to determine user ID.', 'FAILED_TO_LOAD_USER_DATA': 'Failed to load user data.', 'INVALID_RESPONSE': 'Invalid response', 'COULD_NOT_LOAD_USER_INFO': 'Could not load user info.', 'PROFILE_UPDATED_SUCCESSFULLY': 'Profile updated successfully', 'UPDATE_FAILED': 'Update failed.', 'SOMETHING_WENT_WRONG': 'Something went wrong. Try again.', 'PASSWORD_IS_CORRECT': '✔ Password is correct', 'INCORRECT_PASSWORD': 'Incorrect password', 'ERROR_VERIFYING_PASSWORD': 'Error verifying password', 'PASSWORDS_DO_NOT_MATCH': '❌ Passwords do not match', 'PASSWORDS_MATCH': '✔ Passwords match', 'IMAGE_UPLOAD_FAILED': 'Image upload failed', 'IMAGE_UPLOAD_ERROR': 'Image upload error', 'NAME_REQUIRED': 'Name is required and must be at least 2 characters', 'VALID_EMAIL_REQUIRED': 'Valid email is required', 'USERNAME_REQUIRED': 'Username is required and must be at least 3 characters', 'NO_NAME': 'No Name', 'NO_BIO': 'No bio yet',  'CREATE_NEW_STORY': 'Create New Story', 'EDIT_STORY': 'Edit Story', 'STORY_TITLE': 'Story Title', 'ENTER_STORY_TITLE': 'Enter your story title', 'STORY_DESCRIPTION': 'Story Description', 'ENTER_STORY_DESCRIPTION': 'Enter your story description', 'COVER_IMAGE': 'Cover Image', 'DRAG_DROP_IMAGE': 'Drag & drop your cover image here', 'BROWSE_FILES': 'Browse Files', 'CHANGE_IMAGE': 'Change Image', 'REMOVE_IMAGE': 'Remove Image', 'MAX_FILE_SIZE': 'Max file size: 1MB', 'CATEGORY': 'Category', 'SELECT_CATEGORY': 'Select a category', 'AUDIENCE': 'Audience', 'SELECT_AUDIENCE': 'Select audience', 'COPYRIGHT': 'Copyright', 'SELECT_COPYRIGHT': 'Select copyright', 'TAGS': 'Tags', 'ADD_TAGS_PLACEHOLDER': 'Add tags separated by commas', 'TAGS_INSTRUCTION': 'Press comma or enter to add tags', 'CREATE_STORY': 'Create Story', 'UPDATE_STORY': 'Update Story', 'VALIDATE_FORM': 'Validate Form', 'STORY_CREATED_SUCCESSFULLY': 'Story created successfully', 'STORY_UPDATED_SUCCESSFULLY': 'Story updated successfully', 'STORY_TITLE_REQUIRED': 'Story title is required', 'CATEGORY_REQUIRED': 'Category is required', 'LANGUAGE_REQUIRED': 'Language is required', 'EVERYONE': 'Everyone', 'TEEN': 'Teen', 'MATURE': 'Mature', 'ALL_RIGHTS_RESERVED': 'All Rights Reserved', 'CREATIVE_COMMONS': 'Creative Commons', 'PUBLIC_DOMAIN': 'Public Domain', 'OR': 'or', 'FILE_SIZE_LIMIT': 'File size must be 1MB or less.', 'MUST_BE_LOGGED_IN': 'You must be logged in to save a story.', 'UNEXPECTED_STATUS': 'Operation completed but with unexpected status', 'NETWORK_SERVER_ERROR': 'Network/server error occurred',  'CHOOSE_YOUR_LANGUAGE': 'Choose Your Language', 'SELECT_PREFERRED_LANGUAGE': 'Select your preferred language for the best experience', 'SELECTION_SAVED_FUTURE': 'Your selection will be saved for future visits',  'ENGLISH': 'English', 'HINDI': 'Hindi', 'MARATHI': 'Marathi', 'BENGALI': 'Bangla', 'TAMIL': 'Tamil', 'TELUGU': 'Telugu',  'PRIVATE_INFORMATION': 'Private Information', 'BASIC_INFORMATION': 'Basic Information', 'FULL_NAME_REQUIRED': 'Full Name is required', 'ENTER_VALID_EMAIL': 'Enter a valid email', 'MOBILE_10_DIGITS': 'Mobile number must be exactly 10 digits.', 'MOBILE_MAX_10_DIGITS': 'Mobile number cannot exceed 10 digits.', 'FOLLOWERS': 'followers', 'CHAPTERS': 'Chapters', 'FOLLOWING': 'following', 'LISTEN_TO_THIS_STORY': 'Listen to this story', 'SHARE_THIS_STORY': 'Share this story', 'RATINGS': 'ratings', 'FORM': 'form', 'CONTINUE_TO_NEXT': 'अगले भाग के लिए जारी रखें', 'END_STORY': 'END STORY', 'POST': 'Post', 'SEARCH_RESULT': 'Search Result', 'NO_SEARCH_RESULTS': 'No search results found', 'NO_CONTENT_FOUND': 'No content found', 'RELATED_LISTS': 'Related Lists', 'YOUR_READING_HISTORY': 'Your Reading History', 'CLEAR_HISTORY': 'Clear History', 'LOAD_MORE': 'Load More', 'UPLOAD_STORY_COVER': 'Upload your story cover', 'JPEG_PNG_RECOMMENDED': 'JPEG or PNG, 800x1200 recommended', 'STORY': 'Story', 'DESCRIPTION': 'Description', 'TITLE': 'Title', 'CATEGORY_SELECT': 'Category, Select a category', 'TAGS_UP_TO_5': 'Tags (up to 5)', 'ALL_AUDIENCES': 'All Audiences', 'YOUNG_ADULT': 'Young Adult', 'ABOUT_WRITER': 'About Writer', 'CREATIONS': 'रचनाएँ', 'UPDATED': 'Updated', 'NEW_EPISODE': 'New Episode', 'VIEW_EDIT_EPISODE': 'View / Edit Episode', 'VIEW_EPISODE': 'View Episode', 'NO_FOLLOWERS_YET': 'No followers yet', 'NOT_FOLLOWING_ANYONE': 'Not following anyone yet', 'PUBLISH': 'Publish', 'SAVE_DRAFT': 'Save Draft', 'VIEW_MORE_COMMENTS': 'View more comments', 'COMMENTING_AS': 'Commenting as', 'SIGN_IN_TO_COMMENT': 'Please sign in to add a comment', 'POST_COMMENT': 'Post Comment',
        'CREATE_COVER': 'Create Cover',
    'CREATE_STORY_COVER': 'Create Story Cover',
    'COPY_THE_PROMPT_BELOW': 'Copy the prompt below and use it in grok AI to generate your story cover:',
    'AI_COVER_PROMPT': 'AI Cover Prompt',
    'COPY_PROMPT': 'Copy Prompt',
    'GO_TO_SORA': 'Go to grok AI',
    'INSTRUCTIONS': 'Instructions',
    'COPY_THE_PROMPT_ABOVE': 'Copy the prompt above',
    'GO_TO_SORA_WEBSITE': 'Go to ⁠https://grok.com/imagine website',
    'PASTE_THE_PROMPT': 'Paste the prompt in grok AI',
    'GENERATE_AND_DOWNLOAD': 'Generate and download your cover image',
    'UPLOAD_COVER_ABOVE': 'Upload the generated cover using the upload section above',
      'PROMPT_AI':'Vertical 9:16 ultra-realistic poster for story titled “{यहाँ अपनी कहानी का नाम लिखें}” in bold cracked white Hindi typography. Add the text “{यहाँ अपना लेखक नाम लिखें} Story” in red below the title.  Show {मुख्य किरदार का वर्णन यहाँ लिखें — उम्र, लड़का/लड़की, कपड़े, मूड} Create a {स्थान का वर्णन — जंगल/हॉस्पिटल/हवेली/कमरा/रेलवे स्टेशन आदि} with dramatic shadows, fog, and cinematic lighting. Keep the atmosphere {हॉरर/थ्रिलर/रोमांटिक/फैंटेसी/मिस्ट्री में से एक चुनें} with ultra-realistic detail, high contrast lighting, and 3D depth. Use {डार्क / कॉन्ट्रास्ट / वॉर्म / कोल्ड / नियॉन / रेट्रो — कोई भी चुनें} color palette.',
      'ADD_NEW_EPISODE':'ADD NEW EPISODE',
      'WRITE_FIRST_STORY': 'Write First Story',
    'NO_STORIES': 'No stories',
    'PUBLISH_FIRST_STORY': 'Publish your first story',
    'GET_EARLY_ADVANTAGE': 'and get the early-mover advantage',
    'STORIES_IN_OTHER_LANGUAGES':'STORIES IN OTHER LANGUAGES',
  },

    hi: {
  "NEW_RELEASES": "नई रिलीज़",
  "TRENDING": "प्रचलित",
  "CATEGORIES": "श्रेणियाँ",
  "TOP_WRITERS": "शीर्ष लेखक",
  "CONTINUE_READING": "पढ़ना जारी रखें",
  "SEE_ALL": "सभी देखें",
  "SEE_MORE": "और देखें",
  "SEE_LESS": "कम देखें",
  "BY": "द्वारा",
  "READS": "पढ़े गए",
  'WRITE_FIRST_STORY': 'पहली कहानी लिखें',
    'NO_STORIES': 'कोई कहानी नहीं',
  "VIEWS": "दृश्य",
  "READ_NOW": "अभी पढ़ें",
  "ADD_TO_LIBRARY": "लाइब्रेरी में जोड़ें",
  "REMOVE_FROM_LIBRARY": "लाइब्रेरी से हटाएँ",
  "FOLLOW": "अनुसरण करें",
  "UNFOLLOW": "अनुसरण रोकें",
  "STORIES": "कहानियाँ",
  "CATEGORIES_MENU": "श्रेणियाँ",
  "WRITING_CONTEST": "लेखन प्रतियोगिता",
  "SEARCH_PLACEHOLDER": "कहानियों के लिए खोजें...",
  "SIGN_IN": "साइन इन",
  "SIGN_OUT": "साइन आउट",
  "WRITE": "लिखें",
  "MY_STORIES": "मेरी कहानियाँ",
  "MY_PROFILE": "मेरा प्रोफ़ाइल",
  "LIBRARY": "लाइब्रेरी",
  "LANGUAGE": "भाषा",
  "EDIT_PROFILE": "प्रोफ़ाइल संपादित करें",
  "FULL_NAME": "पूरा नाम",
  "EMAIL_ADDRESS": "ईमेल पता",
  "USERNAME": "उपयोगकर्ता नाम",
  "MOBILE_NUMBER": "मोबाइल नंबर",
  "ABOUT_ME": "मेरे बारे में",
  "TELL_US_ABOUT_YOURSELF": "अपने बारे में बताएं",
  "PREFERRED_LANGUAGE": "पसंदीदा भाषा",
  "CHANGE_PASSWORD": "पासवर्ड बदलें",
  "CURRENT_PASSWORD": "वर्तमान पासवर्ड",
  "NEW_PASSWORD": "नया पासवर्ड",
  "CONFIRM_PASSWORD": "पासवर्ड की पुष्टि करें",
  "UPDATE_PROFILE": "प्रोफ़ाइल अपडेट करें",
  "UPDATING": "अपडेट हो रहा है...",
  "CHANGE_COVER": "कवर बदलें",
  "UPLOADING": "अपलोड हो रहा है...",
  "CHARACTERS": "अक्षर",
  "UNABLE_TO_DETERMINE_USER_ID": "उपयोगकर्ता आईडी निर्धारित नहीं की जा सकी।",
  "FAILED_TO_LOAD_USER_DATA": "उपयोगकर्ता डेटा लोड करने में विफल।",
  "INVALID_RESPONSE": "अमान्य प्रतिक्रिया",
  "COULD_NOT_LOAD_USER_INFO": "उपयोगकर्ता जानकारी लोड नहीं की जा सकी।",
  "PROFILE_UPDATED_SUCCESSFULLY": "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई",
  "UPDATE_FAILED": "अपडेट विफल।",
  "SOMETHING_WENT_WRONG": "कुछ गलत हो गया। पुनः प्रयास करें।",
  "PASSWORD_IS_CORRECT": "✔ पासवर्ड सही है",
  "INCORRECT_PASSWORD": "गलत पासवर्ड",
  "ERROR_VERIFYING_PASSWORD": "पासवर्ड सत्यापित करने में त्रुटि",
  "PASSWORDS_DO_NOT_MATCH": "❌ पासवर्ड मेल नहीं खाते",
  "PASSWORDS_MATCH": "✔ पासवर्ड मेल खाते हैं",
  "IMAGE_UPLOAD_FAILED": "छवि अपलोड विफल",
  "IMAGE_UPLOAD_ERROR": "छवि अपलोड त्रुटि",
  "NAME_REQUIRED": "नाम आवश्यक है और कम से कम 2 अक्षर होना चाहिए",
  "VALID_EMAIL_REQUIRED": "मान्य ईमेल आवश्यक है",
  "USERNAME_REQUIRED": "उपयोगकर्ता नाम आवश्यक है और कम से कम 3 अक्षर होना चाहिए",
  "NO_NAME": "कोई नाम नहीं",
  "NO_BIO": "अभी कोई बायो नहीं",

  "CREATE_NEW_STORY": "नई कहानी बनाएं",
  "EDIT_STORY": "कहानी संपादित करें",
  "STORY_TITLE": "कहानी का शीर्षक",
  "ENTER_STORY_TITLE": "अपनी कहानी का शीर्षक दर्ज करें",
  "STORY_DESCRIPTION": "कहानी का विवरण",
  "ENTER_STORY_DESCRIPTION": "अपनी कहानी का विवरण दर्ज करें",
  "COVER_IMAGE": "कवर छवि",
  "DRAG_DROP_IMAGE": "अपनी कवर छवि यहां खींचें और छोड़ें",
  "BROWSE_FILES": "फ़ाइलें ब्राउज़ करें",
  "CHANGE_IMAGE": "छवि बदलें",
  "REMOVE_IMAGE": "छवि हटाएँ",
  "MAX_FILE_SIZE": "अधिकतम फ़ाइल आकार: 1MB",
  "CATEGORY": "श्रेणी",
  "SELECT_CATEGORY": "श्रेणी चुनें",
  "AUDIENCE": "दर्शक",
  "SELECT_AUDIENCE": "दर्शक चुनें",
  "COPYRIGHT": "कॉपीराइट",
  "SELECT_COPYRIGHT": "कॉपीराइट चुनें",
  "TAGS": "टैग",
  "ADD_TAGS_PLACEHOLDER": "कॉमा से अलग किए गए टैग जोड़ें",
  "TAGS_INSTRUCTION": "टैग जोड़ने के लिए कॉमा या एंटर दबाएँ",
  "CREATE_STORY": "कहानी बनाएं",
  "UPDATE_STORY": "कहानी अपडेट करें",
  "VALIDATE_FORM": "फ़ॉर्म सत्यापित करें",
  "STORY_CREATED_SUCCESSFULLY": "कहानी सफलतापूर्वक बनाई गई",
  "STORY_UPDATED_SUCCESSFULLY": "कहानी सफलतापूर्वक अपडेट की गई",
  "STORY_TITLE_REQUIRED": "कहानी का शीर्षक आवश्यक है",
  "CATEGORY_REQUIRED": "श्रेणी आवश्यक है",
  "LANGUAGE_REQUIRED": "भाषा आवश्यक है",
  "EVERYONE": "सभी",
  "TEEN": "किशोर",
  "MATURE": "प्रौढ़",
  "ALL_RIGHTS_RESERVED": "सर्वाधिकार सुरक्षित",
  "CREATIVE_COMMONS": "क्रिएटिव कॉमन्स",
  "PUBLIC_DOMAIN": "सार्वजनिक डोमेन",
  "OR": "या",
  "FILE_SIZE_LIMIT": "फ़ाइल का आकार 1MB या उससे कम होना चाहिए।",
  "MUST_BE_LOGGED_IN": "कहानी सहेजने के लिए आपको लॉग इन होना चाहिए।",
  "UNEXPECTED_STATUS": "ऑपरेशन पूरा हुआ लेकिन अनपेक्षित स्थिति के साथ",
  "NETWORK_SERVER_ERROR": "नेटवर्क/सर्वर त्रुटि हुई",
'STORIES_IN_OTHER_LANGUAGES':'अन्य भाषाओं में कहानियाँ',
  "CHOOSE_YOUR_LANGUAGE": "अपनी भाषा चुनें",
  "SELECT_PREFERRED_LANGUAGE": "सर्वश्रेष्ठ अनुभव के लिए अपनी पसंदीदा भाषा चुनें",
  "SELECTION_SAVED_FUTURE": "आपका चयन भविष्य के लिए सहेजा जाएगा",

  "ENGLISH": "अंग्रेज़ी",
  "HINDI": "हिंदी",
  "MARATHI": "मराठी",
  "BENGALI": "बांग्ला",
  "TAMIL": "तमिल",
  "TELUGU": "तेलुगु",

'OTHER_LANGUAGE_STORIES': 'अन्य भाषाओं में कहानियाँ',
  "PRIVATE_INFORMATION": "निजी जानकारी",
  "BASIC_INFORMATION": "मूलभूत जानकारी",
  "FULL_NAME_REQUIRED": "पूरा नाम आवश्यक है",
  "ENTER_VALID_EMAIL": "मान्य ईमेल दर्ज करें",
  "MOBILE_10_DIGITS": "मोबाइल नंबर ठीक 10 अंकों का होना चाहिए।",
  "MOBILE_MAX_10_DIGITS": "मोबाइल नंबर 10 अंकों से अधिक नहीं हो सकता।",
  "FOLLOWERS": "अनुयायी",
  "CHAPTERS": "अध्याय",
  "FOLLOWING": "अनुसरण कर रहे",
  "LISTEN_TO_THIS_STORY": "यह कहानी सुनें",
  "SHARE_THIS_STORY": "यह कहानी साझा करें",
  "RATINGS": "रेटिंग",
  "FORM": "फॉर्म",
  "CONTINUE_TO_NEXT": "अगले भाग के लिए जारी रखें",
  "END_STORY": "कहानी समाप्त",
  "POST": "पोस्ट",
  "SEARCH_RESULT": "खोज परिणाम",
  "NO_SEARCH_RESULTS": "कोई खोज परिणाम नहीं मिला",
  "NO_CONTENT_FOUND": "कोई सामग्री नहीं मिली",
  "RELATED_LISTS": "संबंधित सूचियाँ",
  "YOUR_READING_HISTORY": "आपका पढ़ने का इतिहास",
  "CLEAR_HISTORY": "इतिहास साफ करें",
  "LOAD_MORE": "और लोड करें",
  "UPLOAD_STORY_COVER": "अपनी कहानी का कवर अपलोड करें",
  "JPEG_PNG_RECOMMENDED": "JPEG या PNG, 800x1200 अनुशंसित",
  "STORY": "कहानी",
  "DESCRIPTION": "विवरण",
  "TITLE": "शीर्षक",
  "CATEGORY_SELECT": "श्रेणी चुनें",
  "TAGS_UP_TO_5": "टैग (अधिकतम 5)",
  "ALL_AUDIENCES": "सभी दर्शक",
  "YOUNG_ADULT": "युवा वयस्क",
  "ABOUT_WRITER": "लेखक के बारे में",
  "CREATIONS": "रचनाएँ",
  "UPDATED": "अद्यतन",
  "NEW_EPISODE": "नया एपिसोड",
  "VIEW_EDIT_EPISODE": "एपिसोड देखें / संपादित करें",
  "VIEW_EPISODE": "एपिसोड देखें",
  "NO_FOLLOWERS_YET": "अभी तक कोई अनुयायी नहीं",
  "NOT_FOLLOWING_ANYONE": "अभी तक किसी को अनुसरण नहीं किया",
  "PUBLISH": "प्रकाशित करें",
  "SAVE_DRAFT": "ड्राफ्ट सहेजें",
  "VIEW_MORE_COMMENTS": "और टिप्पणियाँ देखें",
  "COMMENTING_AS": "इस रूप में टिप्पणी कर रहे हैं",
  "SIGN_IN_TO_COMMENT": "कृपया टिप्पणी जोड़ने के लिए साइन इन करें",
  "POST_COMMENT": "टिप्पणी पोस्ट करें",
  'CREATE_COVER': 'कवर बनाएं',
    'CREATE_STORY_COVER': 'कहानी कवर बनाएं',
    'COPY_THE_PROMPT_BELOW': 'नीचे दिए गए प्रॉम्प्ट को कॉपी करें और अपना कहानी कवर जनरेट करने के लिए सोरा AI में उपयोग करें:',
    'AI_COVER_PROMPT': 'AI कवर प्रॉम्प्ट',
    'COPY_PROMPT': 'प्रॉम्प्ट कॉपी करें',
    'GO_TO_SORA': 'grok AI पर जाएं',
    'INSTRUCTIONS': 'निर्देश',
    'COPY_THE_PROMPT_ABOVE': 'ऊपर दिए गए प्रॉम्प्ट को कॉपी करें',
    'GO_TO_SORA_WEBSITE': 'grok AI वेबसाइट पर जाएं',
    'PASTE_THE_PROMPT': 'प्रॉम्प्ट को सोरा AI में पेस्ट करें',
    'GENERATE_AND_DOWNLOAD': 'अपना कवर इमेज जनरेट करें और डाउनलोड करें',
    'UPLOAD_COVER_ABOVE': 'जनरेट किए गए कवर को ऊपर दिए गए अपलोड सेक्शन का उपयोग करके अपलोड करें',
    'PROMPT_AI':'Vertical 9:16 ultra-realistic poster for story titled “{यहाँ अपनी कहानी का नाम लिखें}” in bold cracked white Hindi typography. Add the text “{यहाँ अपना लेखक नाम लिखें} Story” in red below the title.  Show {मुख्य किरदार का वर्णन यहाँ लिखें — उम्र, लड़का/लड़की, कपड़े, मूड} Create a {स्थान का वर्णन — जंगल/हॉस्पिटल/हवेली/कमरा/रेलवे स्टेशन आदि} with dramatic shadows, fog, and cinematic lighting. Keep the atmosphere {हॉरर/थ्रिलर/रोमांटिक/फैंटेसी/मिस्ट्री में से एक चुनें} with ultra-realistic detail, high contrast lighting, and 3D depth. Use {डार्क / कॉन्ट्रास्ट / वॉर्म / कोल्ड / नियॉन / रेट्रो — कोई भी चुनें} color palette.',
    'ADD_NEW_EPISODE':'नया भाग जोड़ें',
    'PUBLISH_FIRST_STORY': 'अपनी पहली कहानी प्रकाशित करें',
    'GET_EARLY_ADVANTAGE': 'और early-mover advantage प्राप्त करें'
},
   mr: {
  "NEW_RELEASES": "नवीन प्रदर्शने",
  "TRENDING": "लोकप्रिय",
  "CATEGORIES": "वर्ग",
  "TOP_WRITERS": "टॉप लेखक",
  "CONTINUE_READING": "वाचन सुरू ठेवा",
  "SEE_ALL": "सर्व पहा",
  "SEE_MORE": "अधिक पहा",
  "SEE_LESS": "कमी पहा",
  'OTHER_LANGUAGE_STORIES': 'इतर भाषांमधील कथा',
  "BY": "द्वारे",
  "READS": "वाचले",
  'STORIES_IN_OTHER_LANGUAGES':'इतर भाषांमधील कथा',
  "VIEWS": "पढ़े गए",
  "READ_NOW": "आता वाचा",
  "ADD_TO_LIBRARY": "लायब्ररीमध्ये जोडा",
  "REMOVE_FROM_LIBRARY": "लायब्ररीमधून काढा",
  "FOLLOW": "अनुसरण करा",
  "UNFOLLOW": "अनुसरण थांबवा",
  "STORIES": "कथा",
  "CATEGORIES_MENU": "वर्ग",
  "WRITING_CONTEST": "लेखन स्पर्धा",
  "SEARCH_PLACEHOLDER": "कथा शोधा...",
  "SIGN_IN": "साइन इन",
  "SIGN_OUT": "साइन आउट",
  "WRITE": "लिहा",
  "MY_STORIES": "माझ्या कथा",
  "MY_PROFILE": "माझे प्रोफाइल",
  'WRITE_FIRST_STORY': 'पहिली कथा लिहा',
    'NO_STORIES': 'कथा नाहीत',
    'PUBLISH_FIRST_STORY': 'तुमची पहिली कथा प्रकाशित करा',
    'GET_EARLY_ADVANTAGE': 'आणि early-mover advantage मिळवा',
  "LIBRARY": "लायब्ररी",
  "LANGUAGE": "भाषा",
  "EDIT_PROFILE": "प्रोफाइल संपादित करा",
  "FULL_NAME": "पूर्ण नाव",
  "EMAIL_ADDRESS": "ईमेल पत्ता",
  "USERNAME": "वापरकर्तानाव",
  "MOBILE_NUMBER": "मोबाईल नंबर",
  "ABOUT_ME": "माझ्याबद्दल",
  "TELL_US_ABOUT_YOURSELF": "तुमच्या बद्दल सांगा",
  "PREFERRED_LANGUAGE": "आवडती भाषा",
  "CHANGE_PASSWORD": "पासवर्ड बदला",
  "CURRENT_PASSWORD": "सध्याचा पासवर्ड",
  "NEW_PASSWORD": "नवीन पासवर्ड",
  "CONFIRM_PASSWORD": "पासवर्डची पुष्टी करा",
  "UPDATE_PROFILE": "प्रोफाइल अपडेट करा",
  "UPDATING": "अपडेट करत आहे...",
  "CHANGE_COVER": "कव्हर बदला",
  "UPLOADING": "अपलोड करत आहे...",
  "CHARACTERS": "अक्षरे",
  "UNABLE_TO_DETERMINE_USER_ID": "वापरकर्ता आयडी ठरवता येत नाही.",
  "FAILED_TO_LOAD_USER_DATA": "वापरकर्ता डेटा लोड करण्यात अयशस्वी.",
  "INVALID_RESPONSE": "अमान्य प्रतिसाद",
  "COULD_NOT_LOAD_USER_INFO": "वापरकर्ता माहिती लोड करता आली नाही.",
  "PROFILE_UPDATED_SUCCESSFULLY": "प्रोफाइल यशस्वीरित्या अपडेट केली",
  "UPDATE_FAILED": "अपडेट अयशस्वी.",
  "SOMETHING_WENT_WRONG": "काहीतरी चुकीचे झाले. पुन्हा प्रयत्न करा.",
  "PASSWORD_IS_CORRECT": "✔ पासवर्ड बरोबर आहे",
  "INCORRECT_PASSWORD": "चुकीचा पासवर्ड",
  "ERROR_VERIFYING_PASSWORD": "पासवर्ड पडताळण्यात त्रुटी",
  "PASSWORDS_DO_NOT_MATCH": "❌ पासवर्ड जुळत नाहीत",
  "PASSWORDS_MATCH": "✔ पासवर्ड जुळतात",
  "IMAGE_UPLOAD_FAILED": "प्रतिमा अपलोड अयशस्वी",
  "IMAGE_UPLOAD_ERROR": "प्रतिमा अपलोड त्रुटी",
  "NAME_REQUIRED": "नाव आवश्यक आहे आणि किमान 2 अक्षरे असावी",
  "VALID_EMAIL_REQUIRED": "वैध ईमेल आवश्यक आहे",
  "USERNAME_REQUIRED": "वापरकर्तानाव आवश्यक आहे आणि किमान 3 अक्षरे असावी",
  "NO_NAME": "नाव नाही",
  "NO_BIO": "अजून बायो नाही",

  "CREATE_NEW_STORY": "नवीन कथा तयार करा",
  "EDIT_STORY": "कथा संपादित करा",
  "STORY_TITLE": "कथेचे शीर्षक",
  "ENTER_STORY_TITLE": "कथेचे शीर्षक प्रविष्ट करा",
  "STORY_DESCRIPTION": "कथेचे वर्णन",
  "ENTER_STORY_DESCRIPTION": "कथेचे वर्णन प्रविष्ट करा",
  "COVER_IMAGE": "कव्हर प्रतिमा",
  "DRAG_DROP_IMAGE": "आपली कव्हर प्रतिमा येथे ड्रॅग व ड्रॉप करा",
  "BROWSE_FILES": "फाइल ब्राउझ करा",
  "CHANGE_IMAGE": "प्रतिमा बदला",
  "REMOVE_IMAGE": "प्रतिमा काढा",
  "MAX_FILE_SIZE": "कमाल फाईल आकार: 1MB",
  "CATEGORY": "वर्ग",
  "SELECT_CATEGORY": "वर्ग निवडा",
  "AUDIENCE": "प्रेक्षक",
  "SELECT_AUDIENCE": "प्रेक्षक निवडा",
  "COPYRIGHT": "कॉपीराइट",
  "SELECT_COPYRIGHT": "कॉपीराइट निवडा",
  "TAGS": "टॅग",
  "ADD_TAGS_PLACEHOLDER": "कॉमा द्वारे वेगळे टॅग जोडा",
  "TAGS_INSTRUCTION": "टॅग जोडण्यासाठी कॉमा किंवा एंटर दाबा",
  "CREATE_STORY": "कथा तयार करा",
  "UPDATE_STORY": "कथा अपडेट करा",
  "VALIDATE_FORM": "फॉर्म तपासा",
  "STORY_CREATED_SUCCESSFULLY": "कथा यशस्वीरित्या तयार केली",
  "STORY_UPDATED_SUCCESSFULLY": "कथा यशस्वीरित्या अपडेट केली",
  "STORY_TITLE_REQUIRED": "कथेचे शीर्षक आवश्यक आहे",
  "CATEGORY_REQUIRED": "वर्ग आवश्यक आहे",
  "LANGUAGE_REQUIRED": "भाषा आवश्यक आहे",
  "EVERYONE": "सर्व",
  "TEEN": "किशोर",
  "MATURE": "पारखी",
  "ALL_RIGHTS_RESERVED": "सर्व हक्क राखीव",
  "CREATIVE_COMMONS": "क्रिएटिव्ह कॉमन्स",
  "PUBLIC_DOMAIN": "सार्वजनिक क्षेत्र",
  "OR": "किंवा",
  "FILE_SIZE_LIMIT": "फाइल आकार 1MB किंवा कमी असावा.",
  "MUST_BE_LOGGED_IN": "कथा जतन करण्यासाठी आपल्याला लॉग इन करणे आवश्यक आहे.",
  "UNEXPECTED_STATUS": "ऑपरेशन पूर्ण झाले पण अनपेक्षित स्थितीसह",
  "NETWORK_SERVER_ERROR": "नेटवर्क/सर्व्हर त्रुटी",

  "CHOOSE_YOUR_LANGUAGE": "आपली भाषा निवडा",
  "SELECT_PREFERRED_LANGUAGE": "सर्वोत्तम अनुभवासाठी आपली पसंतीची भाषा निवडा",
  "SELECTION_SAVED_FUTURE": "आपली निवड भविष्यातील भेटीसाठी जतन केली जाईल",

  "ENGLISH": "इंग्रजी",
  "HINDI": "हिंदी",
  "MARATHI": "मराठी",
  "BENGALI": "बांग्ला",
  "TAMIL": "तमिळ",
  "TELUGU": "तेलुगू",

  "PRIVATE_INFORMATION": "खाजगी माहिती",
  "BASIC_INFORMATION": "मूलभूत माहिती",
  "FULL_NAME_REQUIRED": "पूर्ण नाव आवश्यक आहे",
  "ENTER_VALID_EMAIL": "वैध ईमेल प्रविष्ट करा",
  "MOBILE_10_DIGITS": "मोबाईल नंबर अचूक 10 अंकांचा असावा.",
  "MOBILE_MAX_10_DIGITS": "मोबाईल नंबर 10 अंकांपेक्षा जास्त नसावा.",
  "FOLLOWERS": "अनुयायी",
  "CHAPTERS": "अध्याय",
  "FOLLOWING": "अनुसरण करत आहेत",
  "LISTEN_TO_THIS_STORY": "ही कथा ऐका",
  "SHARE_THIS_STORY": "ही कथा शेअर करा",
  "RATINGS": "रेटिंग्ज",
  "FORM": "फॉर्म",
  "CONTINUE_TO_NEXT": "पुढील भागासाठी सुरू ठेवा",
  "END_STORY": "कथा समाप्त",
  "POST": "पोस्ट",
  "SEARCH_RESULT": "शोध परिणाम",
  "NO_SEARCH_RESULTS": "कोणतेही शोध परिणाम नाहीत",
  "NO_CONTENT_FOUND": "कोणतीही सामग्री सापडली नाही",
  "RELATED_LISTS": "संबंधित सूची",
  "YOUR_READING_HISTORY": "आपला वाचन इतिहास",
  "CLEAR_HISTORY": "इतिहास साफ करा",
  "LOAD_MORE": "अधिक लोड करा",
  "UPLOAD_STORY_COVER": "कथा कवर अपलोड करा",
  "JPEG_PNG_RECOMMENDED": "JPEG किंवा PNG, 800×1200 शिफारस केले जाते",
  "STORY": "कथा",
  "DESCRIPTION": "वर्णन",
  "TITLE": "शीर्षक",
  "CATEGORY_SELECT": "वर्ग निवडा",
  "TAGS_UP_TO_5": "टॅग (कमीत कमी 5)",
  "ALL_AUDIENCES": "सर्व प्रेक्षक",
  "YOUNG_ADULT": "तरुण प्रौढ",
  "ABOUT_WRITER": "लेखक बद्दल",
  "CREATIONS": "रचनाएँ",
  "UPDATED": "अद्यतन",
  "NEW_EPISODE": "नवीन भाग",
  "VIEW_EDIT_EPISODE": "भाग पहा / संपादित करा",
  "VIEW_EPISODE": "भाग पहा",
  "NO_FOLLOWERS_YET": "अजून कोई अनुयायी नाही",
  "NOT_FOLLOWING_ANYONE": "अजून कोणाचाही अनुसरण करत नाही",
  "PUBLISH": "प्रकाशित करा",
  "SAVE_DRAFT": "ड्राफ्ट जतन करा",
  "VIEW_MORE_COMMENTS": "अधिक टिप्पणी पहा",
  "COMMENTING_AS": "याप्रमाणे टिप्पणी करत आहे",
  "SIGN_IN_TO_COMMENT": "कृपया टिप्पणी करण्यासाठी साइन इन करा",
  "POST_COMMENT": "टिप्पणी पोस्ट करा",
  'CREATE_COVER': 'कव्हर तयार करा',
    'CREATE_STORY_COVER': 'कथा कव्हर तयार करा',
    'COPY_THE_PROMPT_BELOW': 'खालील प्रॉम्प्ट कॉपी करा आणि तुमचा कथा कव्हर जनरेट करण्यासाठी सोरा AI मध्ये वापरा:',
    'AI_COVER_PROMPT': 'AI कव्हर प्रॉम्प्ट',
    'COPY_PROMPT': 'प्रॉम्प्ट कॉपी करा',
    'GO_TO_SORA': 'grok AI वर जा',
    'INSTRUCTIONS': 'सूचना',
    'COPY_THE_PROMPT_ABOVE': 'वरील प्रॉम्प्ट कॉपी करा',
    'GO_TO_SORA_WEBSITE': 'grok AI वेबसाइटवर जा',
    'PASTE_THE_PROMPT': 'प्रॉम्प्ट सोरा AI मध्ये पेस्ट करा',
    'GENERATE_AND_DOWNLOAD': 'तुमची कव्हर प्रतिमा जनरेट करा आणि डाउनलोड करा',
    'UPLOAD_COVER_ABOVE': 'जनरेट केलेला कव्हर वरील अपलोड विभाग वापरून अपलोड करा',
    'PROMPT_AI':'Vertical 9:16 ultra-realistic poster for story titled “{यहाँ अपनी कहानी का नाम लिखें}” in bold cracked white Hindi typography. Add the text “{यहाँ अपना लेखक नाम लिखें} Story” in red below the title.  Show {मुख्य किरदार का वर्णन यहाँ लिखें — उम्र, लड़का/लड़की, कपड़े, मूड} Create a {स्थान का वर्णन — जंगल/हॉस्पिटल/हवेली/कमरा/रेलवे स्टेशन आदि} with dramatic shadows, fog, and cinematic lighting. Keep the atmosphere {हॉरर/थ्रिलर/रोमांटिक/फैंटेसी/मिस्ट्री में से एक चुनें} with ultra-realistic detail, high contrast lighting, and 3D depth. Use {डार्क / कॉन्ट्रास्ट / वॉर्म / कोल्ड / नियॉन / रेट्रो — कोई भी चुनें} color palette.',
    'ADD_NEW_EPISODE':'नवीन भाग जोडा'
},
    bn: {
    "NEW_RELEASES": "নতুন প্রকাশ",
  "TRENDING": "জনপ্রিয়",
  "CATEGORIES": "বিভাগ",
  "TOP_WRITERS": "শীর্ষ লেখক",
  "CONTINUE_READING": "পঠন চালিয়ে যান",
  "SEE_ALL": "সব দেখুন",
  "SEE_MORE": "আরও দেখুন",
  "SEE_LESS": "কম দেখুন",
  'STORIES_IN_OTHER_LANGUAGES':'অন্যান্য ভাষায় গল্প',
  "BY": "দ্বারা",
  "READS": "পঠিত",
  "VIEWS": "দৃশ্য",
  'OTHER_LANGUAGE_STORIES': 'অন্যান্য ভাষার গল্প',
  "READ_NOW": "এখন পড়ুন",
  "ADD_TO_LIBRARY": "লাইব্রেরিতে যোগ করুন",
  "REMOVE_FROM_LIBRARY": "লাইব্রেরি থেকে মুছুন",
  "FOLLOW": "অনুসরণ করুন",
  "UNFOLLOW": "অনুসরণ বন্ধ করুন",
  "STORIES": "গল্প",
  "CATEGORIES_MENU": "বিভাগ",
  "WRITING_CONTEST": "লেখার প্রতিযোগিতা",
  "SEARCH_PLACEHOLDER": "গল্প খুঁজুন...",
  "SIGN_IN": "সাইন ইন",
  "SIGN_OUT": "সাইন আউট",
  "WRITE": "লিখুন",
  "MY_STORIES": "আমার গল্প",
  "MY_PROFILE": "আমার প্রোফাইল",
  "LIBRARY": "লাইব্রেরি",
  "LANGUAGE": "ভাষা",
  "EDIT_PROFILE": "প্রোফাইল সম্পাদনা করুন",
  "FULL_NAME": "পূর্ণ নাম",
  "EMAIL_ADDRESS": "ইমেইল ঠিকানা",
  "USERNAME": "ব্যবহারকারীর নাম",
  "MOBILE_NUMBER": "মোবাইল নম্বর",
  "ABOUT_ME": "আমার সম্পর্কে",
  "TELL_US_ABOUT_YOURSELF": "আপনার সম্পর্কে বলুন",
  "PREFERRED_LANGUAGE": "পছন্দের ভাষা",
  "CHANGE_PASSWORD": "পাসওয়ার্ড পরিবর্তন করুন",
  "CURRENT_PASSWORD": "বর্তমান পাসওয়ার্ড",
  "NEW_PASSWORD": "নতুন পাসওয়ার্ড",
  "CONFIRM_PASSWORD": "পাসওয়ার্ড নিশ্চিত করুন",
  "UPDATE_PROFILE": "প্রোফাইল আপডেট করুন",
  "UPDATING": "আপডেট করা হচ্ছে...",
  "CHANGE_COVER": "কভার পরিবর্তন করুন",
  "UPLOADING": "আপলোড করা হচ্ছে...",
  "CHARACTERS": "অক্ষর",
  "UNABLE_TO_DETERMINE_USER_ID": "ব্যবহারকারীর ID নির্ধারণ করা যায়নি।",
  "FAILED_TO_LOAD_USER_DATA": "ব্যবহারকারীর তথ্য লোড করতে ব্যর্থ।",
  "INVALID_RESPONSE": "অবৈধ প্রতিক্রিয়া",
  "COULD_NOT_LOAD_USER_INFO": "ব্যবহারকারীর তথ্য লোড করা যায়নি।",
  "PROFILE_UPDATED_SUCCESSFULLY": "প্রোফাইল সফলভাবে আপডেট হয়েছে",
  "UPDATE_FAILED": "আপডেট ব্যর্থ হয়েছে।",
  "SOMETHING_WENT_WRONG": "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
  "PASSWORD_IS_CORRECT": "✔ পাসওয়ার্ড সঠিক",
  "INCORRECT_PASSWORD": "ভুল পাসওয়ার্ড",
  "ERROR_VERIFYING_PASSWORD": "পাসওয়ার্ড যাচাইতে ত্রুটি",
  "PASSWORDS_DO_NOT_MATCH": "❌ পাসওয়ার্ড মেলে না",
  "PASSWORDS_MATCH": "✔ পাসওয়ার্ড মেলে",
  "IMAGE_UPLOAD_FAILED": "ছবি আপলোড ব্যর্থ",
  "IMAGE_UPLOAD_ERROR": "ছবি আপলোড ত্রুটি",
  "NAME_REQUIRED": "নাম প্রয়োজন এবং কমপক্ষে 2 অক্ষর থাকতে হবে",
  "VALID_EMAIL_REQUIRED": "সঠিক ইমেইল প্রয়োজন",
  "USERNAME_REQUIRED": "ব্যবহারকারীর নাম প্রয়োজন এবং কমপক্ষে 3 অক্ষর থাকতে হবে",
  "NO_NAME": "কোনো নাম নেই",
  "NO_BIO": "এখনো কোনো বায়ো নেই",

  "CREATE_NEW_STORY": "নতুন গল্প তৈরি করুন",
  "EDIT_STORY": "গল্প সম্পাদনা করুন",
  "STORY_TITLE": "গল্পের শিরোনাম",
  "ENTER_STORY_TITLE": "আপনার গল্পের শিরোনাম লিখুন",
  "STORY_DESCRIPTION": "গল্পের বিবরণ",
  "ENTER_STORY_DESCRIPTION": "আপনার গল্পের বিবরণ লিখুন",
  "COVER_IMAGE": "কভার ইমেজ",
  "DRAG_DROP_IMAGE": "এখানে আপনার কভার ইমেজ ড্র্যাগ ও ড্রপ করুন",
  "BROWSE_FILES": "ফাইল ব্রাউজ করুন",
  "CHANGE_IMAGE": "ইমেজ পরিবর্তন করুন",
  "REMOVE_IMAGE": "ইমেজ মুছুন",
  "MAX_FILE_SIZE": "সর্বোচ্চ ফাইল সাইজ: 1MB",
  "CATEGORY": "বিভাগ",
  "SELECT_CATEGORY": "একটি বিভাগ নির্বাচন করুন",
  "AUDIENCE": "দর্শক",
  "SELECT_AUDIENCE": "দর্শক নির্বাচন করুন",
  "COPYRIGHT": "কপিরাইট",
  "SELECT_COPYRIGHT": "কপিরাইট নির্বাচন করুন",
  "TAGS": "ট্যাগ",
  "ADD_TAGS_PLACEHOLDER": "কমা দ্বারা পৃথক ট্যাগ যুক্ত করুন",
  "TAGS_INSTRUCTION": "ট্যাগ যুক্ত করতে কমা বা Enter প্রেস করুন",
  "CREATE_STORY": "গল্প তৈরি করুন",
  "UPDATE_STORY": "গল্প আপডেট করুন",
  "VALIDATE_FORM": "ফর্ম যাচাই করুন",
  "STORY_CREATED_SUCCESSFULLY": "গল্প সফলভাবে তৈরি হয়েছে",
  "STORY_UPDATED_SUCCESSFULLY": "গল্প সফলভাবে আপডেট হয়েছে",
  "STORY_TITLE_REQUIRED": "গল্পের শিরোনাম প্রয়োজন",
  "CATEGORY_REQUIRED": "বিভাগ প্রয়োজন",
  "LANGUAGE_REQUIRED": "ভাষা প্রয়োজন",
  "EVERYONE": "সবার জন্য",
  "TEEN": "কিশোর",
  "MATURE": "পরিপক্ক",
  "ALL_RIGHTS_RESERVED": "সকল অধিকার সংরক্ষিত",
  "CREATIVE_COMMONS": "ক্রিয়েটিভ কমন্স",
  "PUBLIC_DOMAIN": "পাবলিক ডোমেইন",
  "OR": "বা",
  "FILE_SIZE_LIMIT": "ফাইল আকার 1MB বা তার কম হতে হবে।",
  "MUST_BE_LOGGED_IN": "গল্প সেভ করতে আপনাকে লগইন করতে হবে।",
  "UNEXPECTED_STATUS": "অপারেশন সম্পন্ন হয়েছে কিন্তু অপ্রত্যাশিত অবস্থা সহ",
  "NETWORK_SERVER_ERROR": "নেটওয়ার্ক/সার্ভার ত্রুটি হয়েছে",

  "CHOOSE_YOUR_LANGUAGE": "আপনার ভাষা নির্বাচন করুন",
  "SELECT_PREFERRED_LANGUAGE": "সেরা অভিজ্ঞতার জন্য আপনার পছন্দের ভাষা নির্বাচন করুন",
  "SELECTION_SAVED_FUTURE": "আপনার পছন্দ ভবিষ্যতের জন্য সংরক্ষিত হবে",

  "ENGLISH": "ইংরেজি",
  "HINDI": "হিন্দি",
  "MARATHI": "মারাঠি",
  "BENGALI": "বাংলা",
  "TAMIL": "তামিল",
  "TELUGU": "তেলুগু",

  "PRIVATE_INFORMATION": "ব্যক্তিগত তথ্য",
  "BASIC_INFORMATION": "মৌলিক তথ্য",
  "FULL_NAME_REQUIRED": "পূর্ণ নাম আবশ্যক",
  "ENTER_VALID_EMAIL": "একটি বৈধ ইমেইল লিখুন",
  "MOBILE_10_DIGITS": "মোবাইল নম্বরটি অবশ্যই 10 অঙ্কের হতে হবে।",
  "MOBILE_MAX_10_DIGITS": "মোবাইল নম্বর 10 অঙ্কের বেশি হতে পারে না।",
  "FOLLOWERS": "অনুসারক",
  "CHAPTERS": "অধ্যায়",
  "FOLLOWING": "অনুসরণ করছে",
  "LISTEN_TO_THIS_STORY": "এই গল্প শুনুন",
  "SHARE_THIS_STORY": "এই গল্প শেয়ার করুন",
  "RATINGS": "রেটিং",
  "FORM": "ফর্ম",
  "CONTINUE_TO_NEXT": "পরবর্তী অংশে চালিয়ে যান",
  "END_STORY": "গল্প শেষ",
  "POST": "পোস্ট",
  "SEARCH_RESULT": "অনুসন্ধান ফলাফল",
  "NO_SEARCH_RESULTS": "কোনো অনুসন্ধান ফলাফল পাওয়া যায়নি",
  "NO_CONTENT_FOUND": "কোনো বিষয়বস্তু পাওয়া যায়নি",
  "RELATED_LISTS": "সম্পর্কিত তালিকা",
  "YOUR_READING_HISTORY": "আপনার পঠন ইতিহাস",
  "CLEAR_HISTORY": "ইতিহাস মুছুন",
  "LOAD_MORE": "আরও লোড করুন",
  "UPLOAD_STORY_COVER": "গল্পের কভার আপলোড করুন",
  "JPEG_PNG_RECOMMENDED": "JPEG বা PNG, 800×1200 পরামর্শিত",
  "STORY": "গল্প",
  "DESCRIPTION": "বর্ণনা",
  "TITLE": "শিরোনাম",
  "CATEGORY_SELECT": "বিভাগ নির্বাচন করুন",
  "TAGS_UP_TO_5": "ট্যাগ (সর্বোচ্চ 5)",
  "ALL_AUDIENCES": "সব দর্শকের জন্য",
  "YOUNG_ADULT": "যুবক",
  "ABOUT_WRITER": "লেখক সম্পর্কে",
  "CREATIONS": "रचनाएँ",
  "UPDATED": "আপডেটেড",
  "NEW_EPISODE": "নতুন পর্ব",
  "VIEW_EDIT_EPISODE": "পর্ব দেখুন / সম্পাদনা করুন",
  "VIEW_EPISODE": "পর্ব দেখুন",
  "NO_FOLLOWERS_YET": "এখনও কোনো অনুসারী নেই",
  "NOT_FOLLOWING_ANYONE": "কাউকে অনুসরণ করছেন না",
  "PUBLISH": "প্রকাশ করুন",
  "SAVE_DRAFT": "ড্রাফ্ট সেভ করুন",
  "VIEW_MORE_COMMENTS": "আরো মন্তব্য দেখুন",
  "COMMENTING_AS": "এই নামে মন্তব্য করছেন",
  "SIGN_IN_TO_COMMENT": "মন্তব্য করতে দয়া করে সাইন ইন করুন",
  "POST_COMMENT": "মন্তব্য পোস্ট করুন",
  'CREATE_COVER': 'কভার তৈরি করুন',
    'CREATE_STORY_COVER': 'গল্পের কভার তৈরি করুন',
    'COPY_THE_PROMPT_BELOW': 'নীচের প্রম্পটটি কপি করুন এবং আপনার গল্পের কভার তৈরি করতে সোরা AI-তে ব্যবহার করুন:',
    'AI_COVER_PROMPT': 'AI কভার প্রম্পট',
    'COPY_PROMPT': 'প্রম্পট কপি করুন',
    'GO_TO_SORA': 'grok AI-তে যান',
    'INSTRUCTIONS': 'নির্দেশাবলী',
    'COPY_THE_PROMPT_ABOVE': 'উপরের প্রম্পটটি কপি করুন',
    'GO_TO_SORA_WEBSITE': 'grok AI ওয়েবসাইটে যান',
    'PASTE_THE_PROMPT': 'প্রম্পটটি সোরা AI-তে পেস্ট করুন',
    'GENERATE_AND_DOWNLOAD': 'আপনার কভার ইমেজ জেনারেট করুন এবং ডাউনলোড করুন',
    'UPLOAD_COVER_ABOVE': 'জেনারেট করা কভার উপরের আপলোড সেকশন ব্যবহার করে আপলোড করুন',
    'PROMPT_AI':'Vertical 9:16 ultra-realistic poster for story titled “{यहाँ अपनी कहानी का नाम लिखें}” in bold cracked white Hindi typography. Add the text “{यहाँ अपना लेखक नाम लिखें} Story” in red below the title.  Show {मुख्य किरदार का वर्णन यहाँ लिखें — उम्र, लड़का/लड़की, कपड़े, मूड} Create a {स्थान का वर्णन — जंगल/हॉस्पिटल/हवेली/कमरा/रेलवे स्टेशन आदि} with dramatic shadows, fog, and cinematic lighting. Keep the atmosphere {हॉरर/थ्रिलर/रोमांटिक/फैंटेसी/मिस्ट्री में से एक चुनें} with ultra-realistic detail, high contrast lighting, and 3D depth. Use {डार्क / कॉन्ट्रास्ट / वॉर्म / कोल्ड / नियॉन / रेट्रो — कोई भी चुनें} color palette.',
    'ADD_NEW_EPISODE':'নতুন এপিসোড যোগ করুন',
    'WRITE_FIRST_STORY': 'প্রথম গল্প লিখুন',
    'NO_STORIES': 'কোন গল্প নেই',
    'PUBLISH_FIRST_STORY': 'আপনার প্রথম গল্প প্রকাশ করুন',
    'GET_EARLY_ADVANTAGE': 'এবং early-mover advantage পান'
},
    ta: {
      'STORIES_IN_OTHER_LANGUAGES':'மற்ற மொழிகளில் கதைகள்',
     "NEW_RELEASES": "புதிய வெளியீடுகள்",
     'OTHER_LANGUAGE_STORIES': 'பிற மொழிகளில் கதைகள்',
  "TRENDING": "பிரபலமானவை",
  "CATEGORIES": "வகைகள்",
  "TOP_WRITERS": "சிறந்த எழுத்தாளர்கள்",
  "CONTINUE_READING": "படிப்பை தொடரவும்",
  "SEE_ALL": "அனைத்தையும் பார்க்கவும்",
  "SEE_MORE": "மேலும் பார்க்கவும்",
  "SEE_LESS": "குறைவாக பார்க்கவும்",
  "BY": "இருந்து",
  "READS": "படித்தவர்",
  "VIEWS": "காண்வுகள்",
  "READ_NOW": "இப்போதே படிக்கவும்",
  "ADD_TO_LIBRARY": "லிப்ரரிக்கு சேர்க்கவும்",
  "REMOVE_FROM_LIBRARY": "லிப்ரரியில் இருந்து நீக்கவும்",
  "FOLLOW": "பின்தொடரவும்",
  "UNFOLLOW": "பின்தொடரலை நிறுத்தவும்",
  "STORIES": "கதைகள்",
  "CATEGORIES_MENU": "வகைகள்",
  "WRITING_CONTEST": "எழுத்துப் போட்டி",
  "SEARCH_PLACEHOLDER": "கதைகள் தேடவும்...",
  "SIGN_IN": "உள்நுழையவும்",
  "SIGN_OUT": "வெளியேறு",
  "WRITE": "எழுது",
  "MY_STORIES": "எனது கதைகள்",
  "MY_PROFILE": "எனது சுயவிவரம்",
  "LIBRARY": "லிப்ரரி",
  "LANGUAGE": "மொழி",
  "EDIT_PROFILE": "சுயவிவரத்தைத் திருத்தவும்",
  "FULL_NAME": "முழு பெயர்",
  "EMAIL_ADDRESS": "மின்னஞ்சல் முகவரி",
  "USERNAME": "பயனர் பெயர்",
  "MOBILE_NUMBER": "மொபைல் எண்",
  "ABOUT_ME": "என்னைப் பற்றி",
  "TELL_US_ABOUT_YOURSELF": "உங்களது பற்றி எங்களிடம் சொல்லவும்",
  "PREFERRED_LANGUAGE": "முன்னுரிமை மொழி",
  "CHANGE_PASSWORD": "கடவுச் சொல்லை மாற்றவும்",
  "CURRENT_PASSWORD": "தற்போதைய கடவுச் சொல்",
  "NEW_PASSWORD": "புதிய கடவுச் சொல்",
  "CONFIRM_PASSWORD": "கடவுச் சொல்லை உறுதிப்படுத்தவும்",
  "UPDATE_PROFILE": "சுயவிவரம் புதுப்பிக்கவும்",
  "UPDATING": "புதுப்பிக்கப்படுகிறது...",
  "CHANGE_COVER": "முகப்புப் படத்தை மாற்றவும்",
  "UPLOADING": "பதிவு செய்யப்படுகிறது...",
  "CHARACTERS": "அக்சரங்கள்",
  "UNABLE_TO_DETERMINE_USER_ID": "பயனர் ஐடியை தீர்மானிக்க முடியவில்லை.",
  "FAILED_TO_LOAD_USER_DATA": "பயனர் தரவை ஏற்ற முடியவில்லை.",
  "INVALID_RESPONSE": "தவறான பதில்",
  "COULD_NOT_LOAD_USER_INFO": "பயனர் தகவலை ஏற்ற முடியவில்லை.",
  "PROFILE_UPDATED_SUCCESSFULLY": "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
  "UPDATE_FAILED": "புதுப்பிப்பு தோல்வியுற்றது.",
  "SOMETHING_WENT_WRONG": "ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்.",
  "PASSWORD_IS_CORRECT": "✔ கடவுச் சொல் சரியானது",
  "INCORRECT_PASSWORD": "தவறான கடவுச் சொல்",
  "ERROR_VERIFYING_PASSWORD": "கடவுச் சொல்லைப் பரிசோதிக்க பிழை",
  "PASSWORDS_DO_NOT_MATCH": "❌ கடவுச் சொற்கள் பொருந்தவில்லை",
  "PASSWORDS_MATCH": "✔ கடவுச் சொற்கள் பொருந்துகின்றன",
  "IMAGE_UPLOAD_FAILED": "படத்தைப் பதிவேற்ற முடியவில்லை",
  "IMAGE_UPLOAD_ERROR": "படப் பதிவேற்ற பிழை",
  "NAME_REQUIRED": "பெயர் தேவையானது மற்றும் குறைந்தது 2 எழுத்துகள் இருக்க வேண்டும்",
  "VALID_EMAIL_REQUIRED": "உரிய மின்னஞ்சல் தேவை",
  "USERNAME_REQUIRED": "பயனர் பெயர் தேவையானது மற்றும் குறைந்தது 3 எழுத்துகள் இருக்க வேண்டும்",
  "NO_NAME": "பெயர் இல்லை",
  "NO_BIO": "இன்னும் பயோ இல்லை",

  "CREATE_NEW_STORY": "புதிய கதை உருவாக்கவும்",
  "EDIT_STORY": "கதை திருத்தவும்",
  "STORY_TITLE": "கதையின் தலைப்பு",
  "ENTER_STORY_TITLE": "உங்கள் கதையின் தலைப்பை உள்ளிடவும்",
  "STORY_DESCRIPTION": "கதையின் விளக்கம்",
  "ENTER_STORY_DESCRIPTION": "கதையின் விளக்கத்தை உள்ளிடவும்",
  "COVER_IMAGE": "முகப்பு படம்",
  "DRAG_DROP_IMAGE": "உங்கள் முகப்பு படத்தை இங்கே இழுத்து விடவும்",
  "BROWSE_FILES": "கோப்புகளைப் பார்வையிடவும்",
  "CHANGE_IMAGE": "படத்தை மாற்றவும்",
  "REMOVE_IMAGE": "படத்தை நீக்கவும்",
  "MAX_FILE_SIZE": "அதிகபட்ச கோப்பு அளவு: 1MB",
  "CATEGORY": "வகை",
  "SELECT_CATEGORY": "வகையை தேர்ந்தெடுக்கவும்",
  "AUDIENCE": "பார்வையாளர்கள்",
  "SELECT_AUDIENCE": "பார்வையாளர்களைத் தேர்ந்தெடுக்கவும்",
  "COPYRIGHT": "காப்புரிமை",
  "SELECT_COPYRIGHT": "காப்புரிமையை தேர்ந்தெடுக்கவும்",
  "TAGS": "தொகுக்கள்",
  "ADD_TAGS_PLACEHOLDER": "கோமாவால் பிரிக்கப்பட்ட டேக் சேர்க்கவும்",
  "TAGS_INSTRUCTION": "டேக் சேர்க்க கோமா அல்லது Enter அழுத்தவும்",
  "CREATE_STORY": "கதை உருவாக்கவும்",
  "UPDATE_STORY": "கதை புதுப்பிக்கவும்",
  "VALIDATE_FORM": "படிவத்தைச் சரிபார்க்கவும்",
  "STORY_CREATED_SUCCESSFULLY": "கதை வெற்றிகரமாக உருவாக்கப்பட்டது",
  "STORY_UPDATED_SUCCESSFULLY": "கதை வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
  "STORY_TITLE_REQUIRED": "கதையின் தலைப்பு தேவை",
  "CATEGORY_REQUIRED": "வகை தேவை",
  "LANGUAGE_REQUIRED": "மொழி தேவை",
  "EVERYONE": "எல்லாருக்கும்",
  "TEEN": "இளையோர்",
  "MATURE": "முதிர்ந்தோர்",
  "ALL_RIGHTS_RESERVED": "அனைத்து உரிமைகள் பாதுகாக்கப்பட்டவை",
  "CREATIVE_COMMONS": "கிரியேட்டிவ் காமன்ஸ்",
  "PUBLIC_DOMAIN": "பொது பகுதி",
  "OR": "அல்லது",
  "FILE_SIZE_LIMIT": "கோப்பின் அளவு 1MB அல்லது அதற்கு குறைவாக இருக்க வேண்டும்.",
  "MUST_BE_LOGGED_IN": "கதை சேமிக்க நீங்கள் உள்நுழைந்திருக்க வேண்டும்.",
  "UNEXPECTED_STATUS": "செயல் முடிந்தது ஆனால் எதிர்பாராத நிலைமைத்துடன்",
  "NETWORK_SERVER_ERROR": "நெட்வொர்க்/சேவையகம் பிழை",

  "CHOOSE_YOUR_LANGUAGE": "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
  "SELECT_PREFERRED_LANGUAGE": "சிறந்த அனுபவத்திற்காக உங்கள் முன்னுரிமை மொழியைத் தேர்ந்தெடுக்கவும்",
  "SELECTION_SAVED_FUTURE": "உங்கள் தேர்வு எதிர்காலத்திற்கு சேமிக்கப்படும்",

  "ENGLISH": "ஆங்கிலம்",
  "HINDI": "ஹிந்தி",
  "MARATHI": "மராத்தி",
  "BENGALI": "பெங்காலி",
  "TAMIL": "தமிழ்",
  "TELUGU": "தெலுங்கு",

  "PRIVATE_INFORMATION": "தனியார் தகவல்",
  "BASIC_INFORMATION": "அடிப்படை தகவல்",
  "FULL_NAME_REQUIRED": "முழுப் பெயர் அவசியம்",
  "ENTER_VALID_EMAIL": "செல்லுபடியான மின்னஞ்சலை உள்ளிடவும்",
  "MOBILE_10_DIGITS": "மொபைல் எண் சரியாக 10 இலக்கங்கள் இருக்க வேண்டும்.",
  "MOBILE_MAX_10_DIGITS": "மொபைல் எண் 10 இலக்கங்களை மீறக்கூடாது.",
  "FOLLOWERS": "பின்தொடர்பவர்கள்",
  "CHAPTERS": "அத்தியாயங்கள்",
  "FOLLOWING": "பின்தொடர்கிறார்",
  "LISTEN_TO_THIS_STORY": "இந்த கதையை கேளுங்கள்",
  "SHARE_THIS_STORY": "இந்த கதையை பகிரவும்",
  "RATINGS": "ரேட்டிங்கள்",
  "FORM": "படிவம்",
  "CONTINUE_TO_NEXT": "அடுத்த பகுதியிற்காக தொடரவும்",
  "END_STORY": "கதை முடிவு",
  "POST": "பதிவு செய்",
  "SEARCH_RESULT": "தேடல் முடிவு",
  "NO_SEARCH_RESULTS": "எந்த தேடல் முடிவும் கிடைக்கவில்லை",
  "NO_CONTENT_FOUND": "எந்த உள்ளடக்கமும் காணப்படவில்லை",
  "RELATED_LISTS": "உறவான பட்டியல்",
  "YOUR_READING_HISTORY": "உங்கள் வாசிப்பு வரலாறு",
  "CLEAR_HISTORY": "வரலாற்றை அழி",
  "LOAD_MORE": "மேலும் ஏற்று",
  "UPLOAD_STORY_COVER": "கதையின் முகப்பை பதிவேற்றவும்",
  "JPEG_PNG_RECOMMENDED": "JPEG அல்லது PNG, 800×1200 பரிந்துரைக்கப்படுகிறது",
  "STORY": "கதை",
  "DESCRIPTION": "விளக்கம்",
  "TITLE": "தலைப்பு",
  "CATEGORY_SELECT": "வகை, ஒரு வகையைத் தேர்ந்தெடுக்கவும்",
  "TAGS_UP_TO_5": "டேக் (அதிகபட்சம் 5)",
  "ALL_AUDIENCES": "எல்லா பார்வையாளர்க்கும்",
  "YOUNG_ADULT": "இளம் பெரியவர்",
  "ABOUT_WRITER": "எழுத்தாளர் குறித்து",
  "CREATIONS": "रचनाएँ",
  "UPDATED": "புதுப்பிக்கப்பட்டது",
  "NEW_EPISODE": "புதிய பகுதி",
  "VIEW_EDIT_EPISODE": "பகுதி பார்க்க / திருத்து",
  "VIEW_EPISODE": "பகுதி பார்க்கவும்",
  "NO_FOLLOWERS_YET": "இன்னும் பின்தொடர்பவர்கள் இல்லை",
  "NOT_FOLLOWING_ANYONE": "இன்னும் யாரையும் பின்தொடரவில்லை",
  "PUBLISH": "பதிவு செய்",
  "SAVE_DRAFT": "வரைவு சேமி",
  "VIEW_MORE_COMMENTS": "மேலும் கருத்துகள் பார்க்கவும்",
  "COMMENTING_AS": "இந்த முறையில் கருத்து செய்கிறார்",
  "SIGN_IN_TO_COMMENT": "கருத்து சேர்க்க சைன்-இன் செய்யவும்",
  "POST_COMMENT": "கருத்து பதிவு செய்",
  'CREATE_COVER': 'கவர் உருவாக்கு',
    'CREATE_STORY_COVER': 'கதை கவர் உருவாக்கு',
    'COPY_THE_PROMPT_BELOW': 'கீழே உள்ள ப்ராம்ப்ட்டை நகலெடுத்து, உங்கள் கதை கவரை உருவாக்க சோரா AI-ல் பயன்படுத்தவும்:',
    'AI_COVER_PROMPT': 'AI கவர் ப்ராம்ப்ட்',
    'COPY_PROMPT': 'ப்ராம்ப்ட்டை நகலெடுக்கவும்',
    'GO_TO_SORA': 'grok AI-க்குச் செல்லவும்',
    'INSTRUCTIONS': 'வழிமுறைகள்',
    'COPY_THE_PROMPT_ABOVE': 'மேலே உள்ள ப்ராம்ப்ட்டை நகலெடுக்கவும்',
    'GO_TO_SORA_WEBSITE': 'grok AI வலைத்தளத்திற்குச் செல்லவும்',
    'PASTE_THE_PROMPT': 'ப்ராம்ப்ட்டை சோரா AI-ல் ஒட்டவும்',
    'GENERATE_AND_DOWNLOAD': 'உங்கள் கவர் படத்தை உருவாக்கி பதிவிறக்கவும்',
    'UPLOAD_COVER_ABOVE': 'உருவாக்கப்பட்ட கவரை மேலே உள்ள பதிவேற்றப் பகுதியைப் பயன்படுத்தி பதிவேற்றவும்',
    'PROMPT_AI':'Vertical 9:16 ultra-realistic poster for story titled “{यहाँ अपनी कहानी का नाम लिखें}” in bold cracked white Hindi typography. Add the text “{यहाँ अपना लेखक नाम लिखें} Story” in red below the title.  Show {मुख्य किरदार का वर्णन यहाँ लिखें — उम्र, लड़का/लड़की, कपड़े, मूड} Create a {स्थान का वर्णन — जंगल/हॉस्पिटल/हवेली/कमरा/रेलवे स्टेशन आदि} with dramatic shadows, fog, and cinematic lighting. Keep the atmosphere {हॉरर/थ्रिलर/रोमांटिक/फैंटेसी/मिस्ट्री में से एक चुनें} with ultra-realistic detail, high contrast lighting, and 3D depth. Use {डार्क / कॉन्ट्रास्ट / वॉर्म / कोल्ड / नियॉन / रेट्रो — कोई भी चुनें} color palette.',
    'ADD_NEW_EPISODE':'புதிய அத்தியாயத்தை சேர்க்கவும்',
    'WRITE_FIRST_STORY': 'முதல் கதையை எழுதுங்கள்',
    'NO_STORIES': 'கதைகள் இல்லை',
    'PUBLISH_FIRST_STORY': 'உங்கள் முதல் கதையை வெளியிடவும்',
    'GET_EARLY_ADVANTAGE': 'மற்றும் early-mover advantage பெறுங்கள்'
},
    te: {
      'STORIES_IN_OTHER_LANGUAGES':'ఇతర భాషలలో కథలు',
    "NEW_RELEASES": "కొత్త వదిలివేతలు",
  "TRENDING": "ట్రెండింగ్",
  "CATEGORIES": "వర్గాలు",
  "TOP_WRITERS": "టాప్ రచయితలు",
  "CONTINUE_READING": "చదవడం కొనసాగించండి",
  "SEE_ALL": "అన్నీ చూడండి",
  "SEE_MORE": "మరిన్ని చూడండి",
  "SEE_LESS": "తక్కువగా చూడండి",
  "BY": "వారు",
  "READS": "వాచులైనవి",
  "VIEWS": "వీక్షణలు",
  "READ_NOW": "ఇప్పుడు చదవండి",
  "ADD_TO_LIBRARY": "లైబ్రరీకి జత చేయండి",
  "REMOVE_FROM_LIBRARY": "లైబ్రరీ నుండి తీసేయండి",
  "FOLLOW": "ఫాలో చేయండి",
  "UNFOLLOW": "ఫాలో నిలిపివేయండి",
  "STORIES": "కథలు",
  "CATEGORIES_MENU": "వర్గాలు",
  "WRITING_CONTEST": "రచన పోటీ",
  "SEARCH_PLACEHOLDER": "కథలను వెతకండి...",
  "SIGN_IN": "సైన్ ఇన్",
  "SIGN_OUT": "సైన్ అవుట్",
  "WRITE": "రాయండి",
  "MY_STORIES": "నా కథలు",
  "MY_PROFILE": "నా ప్రొఫైల్",
  "LIBRARY": "లైబ్రరీ",
  "LANGUAGE": "భాష",
  "EDIT_PROFILE": "ప్రొఫైల్ సవరించండి",
  "FULL_NAME": "పూర్తి పేరు",
  "EMAIL_ADDRESS": "ఇమెయిల్ చిరునామా",
  "USERNAME": "వాడుకరిపేరు",
  "MOBILE_NUMBER": "మొబైల్ నంబర్",
  "ABOUT_ME": "నాకు సంబంధించినది",
  "TELL_US_ABOUT_YOURSELF": "మీ గురించి చెప్పండి",
  "PREFERRED_LANGUAGE": "ఆ первое భాష",
  "CHANGE_PASSWORD": "పాస్వర్డ్ మార్చండి",
  "CURRENT_PASSWORD": "ప్రస్తుత పాస్వర్డ్",
  "NEW_PASSWORD": "కొత్త పాస్వర్డ్",
  "CONFIRM_PASSWORD": "పాస్వర్డ్ ధృవీకరించండి",
  "UPDATE_PROFILE": "ప్రొఫైల్ నవీకరించండి",
  "UPDATING": "నవీకరిస్తోంది...",
  "CHANGE_COVER": "కవర్ మార్చండి",
  "UPLOADING": "అప్‌లోడ్ అవుతోంది...",
  "CHARACTERS": "అక్షరాలు",
  "UNABLE_TO_DETERMINE_USER_ID": "యూజర్ ID గుర్తించలేకపోయాం.",
  "FAILED_TO_LOAD_USER_DATA": "యూజర్ డేటా లోడ్ చేయలేకపోయాం.",
  "INVALID_RESPONSE": "చెల్లని స్పందన",
  "COULD_NOT_LOAD_USER_INFO": "యూజర్ సమాచారం లోడ్ చేయలేకపోయాం.",
  "PROFILE_UPDATED_SUCCESSFULLY": "ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది",
  "UPDATE_FAILED": "నవీకరణ విఫలమైంది.",
  "SOMETHING_WENT_WRONG": "ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి.",
  "PASSWORD_IS_CORRECT": "✔ పాస్వర్డ్ సరైనది",
  "INCORRECT_PASSWORD": "తప్పు పాస్వర్డ్",
  'OTHER_LANGUAGE_STORIES': 'ఇతర భాషలలో కథలు',
  "ERROR_VERIFYING_PASSWORD": "పాస్వర్డ్ చెక్ చేయడంలో లోపం",
  "PASSWORDS_DO_NOT_MATCH": "❌ పాస్వర్డ్స్ సరిపోలవు",
  "PASSWORDS_MATCH": "✔ పాస్వర్డ్స్ సరిపోయాయి",
  "IMAGE_UPLOAD_FAILED": "చిత్రం అప్‌లోడ్ విఫలమైంది",
  "IMAGE_UPLOAD_ERROR": "చిత్రం అప్‌లోడ్ లోపం",
  "NAME_REQUIRED": "పేరు అవసరం, కనీసం 2 అక్షరాలు",
  "VALID_EMAIL_REQUIRED": "చెల్లున ఇమెయిల్ అవసరం",
  "USERNAME_REQUIRED": "వాడుకరిపేరు అవసరం, కనీసం 3 అక్షరాలు",
  "NO_NAME": "పేరు లేదు",
  "NO_BIO": "ఇప్పటి వరకు బయో లేదు",

  "CREATE_NEW_STORY": "కొత్త కథ సృష్టించండి",
  "EDIT_STORY": "కథను సవరించండి",
  "STORY_TITLE": "కథ శీర్షిక",
  "ENTER_STORY_TITLE": "మీ కథ శీర్షికను నమోదు చేయండి",
  "STORY_DESCRIPTION": "కథ వివరణ",
  "ENTER_STORY_DESCRIPTION": "మీ కథ వివరణను నమోదు చేయండి",
  "COVER_IMAGE": "కవర్ చిత్రం",
  "DRAG_DROP_IMAGE": "మీ కవర్ చిత్రాన్ని ఇక్కడ డ్రాగ్ & డ్రాప్ చేయండి",
  "BROWSE_FILES": "ఫైళ్ళను బ్రౌజ్ చేయండి",
  "CHANGE_IMAGE": "చిత్రం మార్చండి",
  "REMOVE_IMAGE": "చిత్రం తొలగించండి",
  "MAX_FILE_SIZE": "గరిష్ట ఫైల్ పరిమాణం: 1MB",
  "CATEGORY": "వర్గం",
  "SELECT_CATEGORY": "ఒక వర్గం ఎంచుకోండి",
  "AUDIENCE": "ప్రేక్షకులు",
  "SELECT_AUDIENCE": "ప్రేక్షకులను ఎంచుకోండి",
  "COPYRIGHT": "కాపీరైట్",
  "SELECT_COPYRIGHT": "కాపీరైట్ ఎంచుకోండి",
  "TAGS": "ట్యాగ్‌లు",
  "ADD_TAGS_PLACEHOLDER": "కామా తో విడదీయబడిన ట్యాగ్‌లు జత చేయండి",
  "TAGS_INSTRUCTION": "ట్యాగ్ జత చేయటానికి కామా లేదా Enter నొక్కండి",
  "CREATE_STORY": "కథను సృష్టించండి",
  "UPDATE_STORY": "కథను నవీకరించండి",
  "VALIDATE_FORM": "పోరమ్ ధృవీకరించండి",
  "STORY_CREATED_SUCCESSFULLY": "కథ విజయవంతంగా సృష్టించబడింది",
  "STORY_UPDATED_SUCCESSFULLY": "కథ విజయవంతంగా నవీకరించబడింది",
  "STORY_TITLE_REQUIRED": "కథ శీర్షిక అవసరం",
  "CATEGORY_REQUIRED": "వర్గం అవసరం",
  "LANGUAGE_REQUIRED": "భాష అవసరం",
  "EVERYONE": "అందరికీ",
  "TEEN": "యువత",
  "MATURE": "పెద్దవారు",
  "ALL_RIGHTS_RESERVED": "అన్ని హక్కులు రిజర్వ్ చేయబడ్డాయి",
  "CREATIVE_COMMONS": "క్రియేటివ్ కామన్స్",
  "PUBLIC_DOMAIN": "పబ్లిక్ డొమైన్",
  "OR": "లేదా",
  "FILE_SIZE_LIMIT": "ఫైల్ పరిమాణం 1MB లేదా తక్కువగా ఉండాలి.",
  "MUST_BE_LOGGED_IN": "కథను సురక్షితం చేసేందుకు మీరు లాగిన్ అయి ఉండాలి.",
  "UNEXPECTED_STATUS": "ఆపరేషన్ పూర్తయింది కానీ ఆశించిన స్థితితో కాదు",
  "NETWORK_SERVER_ERROR": "నెట్‌వర్క్/సర్వర్ లోపం జరిగింది",

  "CHOOSE_YOUR_LANGUAGE": "మీ భాషను ఎంచుకోండి",
  "SELECT_PREFERRED_LANGUAGE": "ఉత్తమ అనుభవం కోసం మీ ప్రాథమిక భాషను ఎంచుకోండి",
  "SELECTION_SAVED_FUTURE": "మీ ఎంపిక భవిష్యత్తులో నిల్వ చేయబడుతుంది",

  "ENGLISH": "ఇంగ్లీష్",
  "HINDI": "హిందీ",
  "MARATHI": "మరాఠీ",
  "BENGALI": "బెంగాలీ",
  "TAMIL": "తమిళం",
  "TELUGU": "తెలుగు",

  "PRIVATE_INFORMATION": "ప్రైవేట్ సమాచారం",
  "BASIC_INFORMATION": "ప్రాథమిక సమాచారం",
  "FULL_NAME_REQUIRED": "పూర్తి పేరు అవసరం",
  "ENTER_VALID_EMAIL": "చెల్లుబడి ఇమెయిల్ ఇవ్వండి",
  "MOBILE_10_DIGITS": "మొబైల్ నంబర్ ఖచ్చితంగా 10 అంకెలు ఉండాలి.",
  "MOBILE_MAX_10_DIGITS": "మొబైల్ నంబర్ 10 అంకెలకంటే ఎక్కువ కాకూడదు.",
  "FOLLOWERS": "ఫాలోవర్స్",
  "CHAPTERS": "అధ్యాయాలు",
  "FOLLOWING": "ఫాలో ఇస్తున్నాడు",
  "LISTEN_TO_THIS_STORY": "ఈ కథ వినండి",
  "SHARE_THIS_STORY": "ఈ కథ షేర్ చేయండి",
  "RATINGS": "రేటింగ్లు",
  "FORM": "ఫారం",
  "CONTINUE_TO_NEXT": "తదుపరి భాగానికి కొనసాగించు",
  "END_STORY": "కథ ముగింపు",
  "POST": "పోస్ట్",
  "SEARCH_RESULT": "శోధన ఫలితం",
  "NO_SEARCH_RESULTS": "ఎలాంటి శోధన ఫలితాలు కనిపించలేదు",
  "NO_CONTENT_FOUND": "ఏవీ విషయాలు కనబడలేదు",
  "RELATED_LISTS": "సంబంధిత జాబితాలు",
  "YOUR_READING_HISTORY": "మీ చదువుల చరిత్ర",
  "CLEAR_HISTORY": "చరిత్ర తొలగించండి",
  "LOAD_MORE": "మరింత లోడ్ చేయండి",
  "UPLOAD_STORY_COVER": "కథకి కవర్ అప్‌లోడ్ చేయండి",
  "JPEG_PNG_RECOMMENDED": "JPEG లేదా PNG, 800×1200 సూచించబడుతుంది",
  "STORY": "కథ",
  "DESCRIPTION": "వివరణ",
  "TITLE": "శీర్షిక",
  "CATEGORY_SELECT": "వర్గం ఎంచుకోండి",
  "TAGS_UP_TO_5": "ట్యాగ్‌లు (అధికంగా 5)",
  "ALL_AUDIENCES": "అన్ని ప్రేక్షకులు",
  "YOUNG_ADULT": "యంగ్ అడల్ట్",
  "ABOUT_WRITER": "రచయిత గురించి",
  "CREATIONS": "रचनाएँ",
  "UPDATED": "నవీకరించబడింది",
  "NEW_EPISODE": "కొత్త ఎపిసోడ్",
  "VIEW_EDIT_EPISODE": "ఎపిసోడ్ వీక్షించు / మార్పు చేయు",
  "VIEW_EPISODE": "ఎపిసోడ్ చూడండి",
  "NO_FOLLOWERS_YET": "ఇప్పుడు వరకు ఫాలోవర్స్ లేరు",
  "NOT_FOLLOWING_ANYONE": "ప్రస్తుతం ఎవరినీ ఫాలో చేయడం లేదు",
  "PUBLISH": "ప్రచురించు",
  "SAVE_DRAFT": "డ్రాఫ్ట్ సేడ్ చేయు",
  "VIEW_MORE_COMMENTS": "మరిన్ని వ్యాఖ్యలు చూడండి",
  "COMMENTING_AS": "ఈ పేరుతో వ్యాఖ్యానిస్తున్నారు",
  "SIGN_IN_TO_COMMENT": "వ్యాఖ్య 추가చేయడానికి దయచేసి సైన్ ఇన్ చేయండి",
  "POST_COMMENT": "వ్యాఖ్య పోస్ట్ చేయండి",
  'CREATE_COVER': 'కవర్ సృష్టించండి',
    'CREATE_STORY_COVER': 'కథ కవర్ సృష్టించండి',
    'COPY_THE_PROMPT_BELOW': 'క్రింద ఉన్న ప్రాంప్ట్‌ను కాపీ చేసి, మీ కథ కవర్‌ను జనరేట్ చేయడానికి సోరా AIలో ఉపయోగించండి:',
    'AI_COVER_PROMPT': 'AI కవర్ ప్రాంప్ట్',
    'COPY_PROMPT': 'ప్రాంప్ట్ కాపీ చేయండి',
    'GO_TO_SORA': 'grok AI వెళ్లండి',
    'INSTRUCTIONS': 'సూచనలు',
    'COPY_THE_PROMPT_ABOVE': 'పైన ఉన్న ప్రాంప్ట్‌ను కాపీ చేయండి',
    'GO_TO_SORA_WEBSITE': 'grok AI వెబ్‌సైట్‌కి వెళ్లండి',
    'PASTE_THE_PROMPT': 'ప్రాంప్ట్‌ను సోరా AIలో పేస్ట్ చేయండి',
    'GENERATE_AND_DOWNLOAD': 'మీ కవర్ ఇమేజ్‌ను జనరేట్ చేసి డౌన్‌లోడ్ చేయండి',
    'UPLOAD_COVER_ABOVE': 'వర్టికల్ 9:16 అల్ట్రా-రీయలిస్టిక్ హారర్-థ్రిల్లర్ పోస్టర్, అందులో “{మీ కథ శీర్షికను నమోదు చేయండి}” బోల్డ్ క్రాక్ అయిన తెల్ల హిందీ టైపోగ్రఫీలో ఉండి, కింద ఎరుపు రంగులో “హారర్ స్టోరీ” అని రాసి ఉంటుంది. {పోస్టర్‌లో మీరు చూపాలనుకునే పాత్రలను వివరించండి.} https://sora.chatgpt.com కు వెళ్లి పోస్టర్ రూపొందించండి.',
    'ADD_NEW_EPISODE':'కొత్త ఎపిసోడ్‌ను జోడించండి',
    'WRITE_FIRST_STORY': 'మొదటి కథ రాయండి',
    'NO_STORIES': 'కథలు లేవు',
    'PUBLISH_FIRST_STORY': 'మీ మొదటి కథను ప్రచురించండి',
    'GET_EARLY_ADVANTAGE': 'మరియు early-mover advantage పొందండి'

}
  };

  constructor() {

    const savedLang = localStorage.getItem('preferredLanguage') || 'en';
    this.currentLang.next(savedLang);
  }

  translate(key: string): string {
    const lang = this.currentLang.value;
    return this.translations[lang]?.[key] || this.translations['en'][key] || key;
  }

  setLanguage(lang: string) {
    this.currentLang.next(lang);
    localStorage.setItem('preferredLanguage', lang);
  }

  getCurrentLanguage(): string {
    return this.currentLang.value;
  }
}
